import { ApplicationCard } from '@sec-loans-ui/common/steps/loan-catalog-step/components/ApplicationCard'
import { ApplicationDetails } from '@sec-loans-ui/common/steps/loan-catalog-step/types'
import { ApplicationSelectData, ApplicationType } from '@sec-loans-ui/common/types'
import { TightSectionContent } from '@ui-components/containers/TightSectionContent'
import { BREAKPOINT_DESKTOP_PX } from '@ui-components/global/constants'
import { TertiaryHeading } from '@ui-components/typography/headings/TertiaryHeading'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

const ApplicationsWrapper = styled(TightSectionContent)`
  @media (min-width: ${BREAKPOINT_DESKTOP_PX}px) {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(424px, 1fr));
  }
`

export const ExistingApplicationsView = ({
  debtorUuid,
  inProgressApplications,
  completedApplications,
  onApplicationSelect,
}: {
  debtorUuid?: string
  inProgressApplications: ApplicationDetails[]
  completedApplications: ApplicationDetails[]
  onApplicationSelect: (input: ApplicationSelectData) => void
}) => {
  const { formatMessage } = useIntl()

  return (
    <TightSectionContent>
      <ApplicationSection
        debtorUuid={debtorUuid}
        applications={inProgressApplications}
        header={formatMessage({ id: 'application-list-in-progress-applications' })}
        additionalText={formatMessage({ id: 'application-list-in-progress-applications-deletion-info' })}
        onApplicationSelect={onApplicationSelect}
      />
      <ApplicationSection
        debtorUuid={debtorUuid}
        applications={completedApplications}
        header={formatMessage({ id: 'application-list-completed-applications' })}
        additionalText={formatMessage({ id: 'application-list-completed-applications-deletion-info' })}
        onApplicationSelect={onApplicationSelect}
      />
    </TightSectionContent>
  )
}

const ApplicationSection = ({
  header,
  additionalText,
  applications,
  onApplicationSelect,
  debtorUuid,
}: {
  header: string
  additionalText: string
  applications: ApplicationDetails[]
  onApplicationSelect: (input: ApplicationSelectData) => void
  debtorUuid?: string
}) => {
  return applications.length > 0 ? (
    <section aria-label={header}>
      <TertiaryHeading header={header} additionalText={additionalText} tagName={'h2'} />
      <ApplicationsWrapper as="ul">
        {applications.map((applicationDetails) => (
          <ApplicationCard
            key={
              applicationDetails.applicationType === ApplicationType.LoanOffer
                ? applicationDetails.applicationMetadata.id
                : applicationDetails.applicationMetadata.applicationId
            }
            debtorUuid={debtorUuid}
            applicationDetails={applicationDetails}
            onApplicationSelect={onApplicationSelect}
          />
        ))}
      </ApplicationsWrapper>
    </section>
  ) : null
}
